<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [areaName]="areaName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [columns]="columns"
  [savingLabel]="'ClientApp.FrontOffice.Financial.CustomerReceiptPayment.settling' | translate"
  [saveLabel]="'ClientApp.FrontOffice.Financial.CustomerReceiptPayment.settlement' | translate"
  (cancelChange)="cancel()"
  (submitChange)="save()">
</dynamic-form>
